import { UseDelegateWalletMessageParams } from 'src/components/DelegateWalletMessage/types';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';
import { abbreviateAddress } from '@velocity-exchange/common';

export default function useDelegateWalletMessage({
	inherited,
}: UseDelegateWalletMessageParams) {
	const rootAuthority = useDriftAccountStore((s) =>
		s.getCurrentUserAccount()?.authority?.toString()
	);
	const isDelegate = useDriftAccountStore(
		(s) => s.getCurrentUserAccount()?.isDelegatedTo
	);

	if (!rootAuthority || !isDelegate) {
		return;
	}

	return `This delegated wallet inherits ${inherited} from the main wallet: ${abbreviateAddress(
		rootAuthority
	)}`;
}
